import React, { useState, useEffect } from "react";
import { getBaseUrl } from "../config";

const JOYSTICK_REFRESH_KEY = "injee_joystick_refresh";

const Joystick = ({
    draftDelay,
    setDraftDelay,
    draftStatus,
    setDraftStatus,
    onJoystickRefresh,
}) => {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (onJoystickRefresh) {
            onJoystickRefresh();
        }
    }, [onJoystickRefresh]);

    const BASE_URL = getBaseUrl();

    const handleSet = async () => {
        const body = {};

        if (draftDelay !== "") body.delay = Number(draftDelay);
        if (draftStatus !== "") body.status = Number(draftStatus);

        if (Object.keys(body).length === 0) {
            setError("Enter at least one value");
            return;
        }

        setLoading(true);
        setError("");
        setSuccess("");

        try {
            const res = await fetch(`${BASE_URL}/joystick`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            });

            if (!res.ok) throw new Error();

            if (onJoystickRefresh) {
                await onJoystickRefresh();
            }

            window.localStorage.setItem(JOYSTICK_REFRESH_KEY, Date.now().toString());
            setSuccess("Updated successfully");
        } catch {
            setError("Failed to update");
        }

        setLoading(false);
    };

    const deleteDelay = async () => {
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            const res = await fetch(`${BASE_URL}/joystick/delay`, {
                method: "DELETE",
            });

            if (!res.ok) throw new Error();

            setDraftDelay("");
            setSuccess("Delay cleared");
            if (onJoystickRefresh) {
                await onJoystickRefresh();
            }
            window.localStorage.setItem(JOYSTICK_REFRESH_KEY, Date.now().toString());
        } catch {
            setError("Failed to delete delay");
        }

        setLoading(false);
    };

    const deleteStatus = async () => {
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            const res = await fetch(`${BASE_URL}/joystick/status`, {
                method: "DELETE",
            });

            if (!res.ok) throw new Error();

            setDraftStatus("");
            setSuccess("Status cleared");
            if (onJoystickRefresh) {
                await onJoystickRefresh();
            }
            window.localStorage.setItem(JOYSTICK_REFRESH_KEY, Date.now().toString());
        } catch {
            setError("Failed to delete status");
        }

        setLoading(false);
    };


    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "60vh"
            }}
        >
            <div style={{ padding: "20px", width: "420px" }}>
                <h2 className="title is-5 has-text-centered">Joystick Control</h2>

                <div className="field">
                    <label className="label">Delay (ms)</label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                            className="input"
                            type="number"
                            value={draftDelay}
                            onChange={(e) => setDraftDelay(e.target.value)}
                        />
                        <button
                            type="button"
                            className="backup-icon-button ml-2"
                            onClick={deleteDelay}
                            disabled={loading}
                            title="Delete delay"
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                </div>

                <div className="field">
                    <label className="label">Status Code</label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                            className="input"
                            type="number"
                            value={draftStatus}
                            onChange={(e) => setDraftStatus(e.target.value)}
                        />
                        <button
                            type="button"
                            className="backup-icon-button ml-2"
                            onClick={deleteStatus}
                            disabled={loading}
                            title="Delete status"
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                </div>

                {error && <p style={{ color: "red" }}>{error}</p>}
                {success && <p style={{ color: "green" }}>{success}</p>}

                <button
                    className={`button is-white mt-3 is-fullwidth joystick-apply-button ${loading ? 'is-loading' : ''}`}
                    onClick={handleSet}
                    disabled={loading}
                >
                    {loading ? "Applying..." : "Apply"}
                </button>
            </div>
        </div>
    );
};

export default Joystick;